{
  "version": "1.2.6",
  "objects": {
    "7452341791831660692": {
      "type": "frame",
      "id": "7452341791831660692",
      "z": -70,
      "textContent": "",
      "left": 3018.162584999526,
      "top": -251.93007668951498,
      "width": 400,
      "height": 500,
      "scaleX": 1.1211403044720032,
      "scaleY": 0.5890661527830701,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7452342821015374210": {
      "type": "frame",
      "id": "7452342821015374210",
      "z": -110,
      "textContent": "Frame 58",
      "left": 3048.162584999526,
      "top": -167.93007668951498,
      "width": 400,
      "height": 500,
      "scaleX": 0.9711403044720032,
      "scaleY": 0.24036539520731248,
      "fill": "#0073CF",
      "opacity": 0.05,
      "container": "7452341791831660692",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452331281022665356": {
      "type": "shape",
      "id": "7452331281022665356",
      "z": 9274,
      "shapeName": "icon",
      "textContent": "",
      "left": 3233.364886880221,
      "top": -140.87307323929448,
      "width": 100,
      "height": 133.33333333333334,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.18051518027411442,
      "scaleY": 0.18051518027411442,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7452342821015374210",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "maskType": "none",
      "iconName": "fas/file-arrow-up",
      "locked": false
    },
    "7452343043401523342": {
      "type": "shape",
      "id": "7452343043401523342",
      "z": 9364,
      "shapeName": "text",
      "textContent": "<p>Drag and drop or <u style=\"color:#5CA5E0\">choose file</u></p>",
      "left": 3148.890645893927,
      "top": -106.80438253607923,
      "width": 187,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 14,
      "angle": 0,
      "container": "7452342821015374210",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7452341891006813701": {
      "type": "frame",
      "id": "7452341891006813701",
      "z": 9324,
      "textContent": "Frame 77",
      "left": 3048.162584999526,
      "top": -27.74737908585874,
      "width": 400,
      "height": 500,
      "scaleX": 0.9711403044720032,
      "scaleY": 0.08070075757575758,
      "fill": "transparent",
      "opacity": 0.5,
      "container": "7452341791831660692",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 5,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "right",
      "layoutAlignVertical": "center"
    },
    "7452341891012878890": {
      "type": "wireframe",
      "id": "7452341891012878890",
      "z": 8542,
      "top": -27.24737908585874,
      "left": 3375.952038850095,
      "width": 59.66666793823242,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452341891006813701",
      "layoutPosition": "a0",
      "wireframeName": "button",
      "fill": "#5CA5E0",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": {
        "state": "default",
        "value": "Save ",
        "iconLeft": null,
        "iconRight": null
      }
    },
    "7452343088568748718": {
      "type": "shape",
      "id": "7452343088568748718",
      "z": 9374,
      "shapeName": "text",
      "textContent": "<p>Upload file</p>",
      "left": 3048.162584999526,
      "top": -221.93007668951498,
      "width": 182,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.1428571428571428,
      "scaleY": 1.1428571428571428,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 16,
      "angle": 0,
      "container": "7452341791831660692",
      "authorId": "7217963293993154848",
      "showAuthor": true,
      "layoutPosition": "a0zz",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    }
  }
}
